import { useMutation } from "@tanstack/react-query";

import { useApiClient } from "../../api-client";

const useSupportTicketUrl = () => {
  const { post } = useApiClient();

  const findSupportTicketUrl = async (): Promise<{ url: string }> => {
    const response = await post("/v1/employees/support-ticket");
    return response.data;
  };

  const getSupportTicketUrl = async () => {
    const url = await findSupportTicketUrl();
    return url;
  };

  return useMutation({ mutationFn: getSupportTicketUrl });
};

export default useSupportTicketUrl;
